export default __webpack_public_path__ + "static/lut-virusi-lutein-zinc-2a878fa30d227912cad0bb3fed7aa6ee.jpg";